import React, { createContext, useContext, useMemo, forwardRef } from 'react';
import classnames from 'classnames';
import styles from './styles.mod.scss';

const BackgroundContext = createContext();

const Background = forwardRef(({ variant, tag, className, ...props }, ref) => {
  const Tag = tag || 'div';
  return (
    <BackgroundContext.Provider value={variant}>
      <Tag
        className={classnames(styles[variant], className)}
        ref={ref}
        {...props}
      />
    </BackgroundContext.Provider>
  );
});

const AccentBackground = forwardRef((props, ref) => (
  <Background variant="accent" ref={ref} {...props} />
));

const MutedBackground = forwardRef((props, ref) => (
  <Background variant="muted" ref={ref} {...props} />
));

const DarkBackground = forwardRef((props, ref) => (
  <Background variant="dark" ref={ref} {...props} />
));

const LightBackground = forwardRef((props, ref) => (
  <Background variant="light" ref={ref} {...props} />
));

const HoverableImageBackground = forwardRef((props, ref) => (
  <Background variant="hoverableImage" ref={ref} {...props} />
));

export default Background;
export {
  AccentBackground,
  MutedBackground,
  DarkBackground,
  LightBackground,
  HoverableImageBackground
};

export function useBackground() {
  const value = useContext(BackgroundContext);
  const isAccent = useMemo(() => value === 'accent', [value]);
  const isMuted = useMemo(() => value === 'muted', [value]);
  const isDark = useMemo(() => value === 'dark' || value === 'hoverableImage', [
    value
  ]);
  return { isAccent, isMuted, isDark };
}
